import React from "react";

import { useTheme, ThemeProvider } from "styled-components";

export const LayoutContext = React.createContext({});

const LayoutProvider = ({ children }) => {
  const theme = useTheme();
  const contextValue = {};

  return (
    <>
      <LayoutContext.Provider value={contextValue}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </LayoutContext.Provider>
    </>
  );
};

export default LayoutProvider;
